import createAction from '@clearscore-group/lib.helpers.create-action';
import createRequestPayload from '@clearscore-group/lib.helpers.create-request-payload';
import { NZ, AU } from '@clearscore-group/lib.config.i18n';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import * as requestStatuses from '@clearscore-group/lib.constants.request-statuses';
import { createSelector } from 'reselect';
import resolveRequest, { getRequestStatus } from '@clearscore-group/lib.helpers.resolve-request';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';
var marketConfig = function marketConfig(market) {
  switch (market) {
    case AU:
      return {
        reidentify: '/au-registration/v1/register/reidentify',
        skipReidentify: '/au-registration/v1/skip-update'
      };
    case NZ:
      return {
        reidentify: '/nz-registration/v1/register/reidentify',
        skipReidentify: '/nz-registration/v1/skip-update'
      };
    default:
      return {
        reidentify: '/cs-identity/v1/reidentify',
        skipReidentify: '/cs-identity/v1/reidentify'
      };
  }
};
var IDENTITY_IDENTIFY = 'CS/IDENTITY_IDENTIFY';
var IDENTITY_IDENTIFY_SUCCESS = "".concat(IDENTITY_IDENTIFY, "_SUCCESS");
var IDENTITY_IDENTIFY_ERROR = "".concat(IDENTITY_IDENTIFY, "_ERROR");
var IDENTITY_REIDENTIFY = 'CS/IDENTITY_REIDENTIFY';
var IDENTITY_REIDENTIFY_SUCCESS = "".concat(IDENTITY_REIDENTIFY, "_SUCCESS");
var IDENTITY_REIDENTIFY_ERROR = "".concat(IDENTITY_REIDENTIFY, "_ERROR");
var IDENTITY_RESTART = 'CS/IDENTITY_RESTART';
var IDENTITY_RESTART_SUCCESS = "".concat(IDENTITY_RESTART, "_SUCCESS");
var IDENTITY_RESTART_ERROR = "".concat(IDENTITY_RESTART, "_ERROR");
var IDENTITY_GENERATE_TOKEN = 'CS/IDENTITY_GENERATE_TOKEN';
var IDENTITY_GENERATE_TOKEN_SUCCESS = "".concat(IDENTITY_GENERATE_TOKEN, "_SUCCESS");
var IDENTITY_GENERATE_TOKEN_ERROR = "".concat(IDENTITY_GENERATE_TOKEN, "_ERROR");
var IDENTITY_VERIFY_OTP_TOKEN = 'CS/IDENTITY_VERIFY_OTP_TOKEN';
var IDENTITY_VERIFY_OTP_TOKEN_SUCCESS = "".concat(IDENTITY_VERIFY_OTP_TOKEN, "_SUCCESS");
var IDENTITY_VERIFY_OTP_TOKEN_ERROR = "".concat(IDENTITY_VERIFY_OTP_TOKEN, "_ERROR");
var IDENTITY_CHOOSE = 'CS/IDENTITY_CHOOSE';
var IDENTITY_CHOOSE_SUCCESS = "".concat(IDENTITY_CHOOSE, "_SUCCESS");
var IDENTITY_CHOOSE_ERROR = "".concat(IDENTITY_CHOOSE, "_ERROR");
var IDENTITY_FIRST_TIME_VISIT = 'CS/IDENTITY_FIRST_TIME_VISIT';
var IDENTITY_FIRST_TIME_REGISTRATION = 'CS/IDENTITY_FIRST_TIME_REGISTRATION';
var IDENTITY_FETCH_KBA = 'CS/IDENTITY_FETCH_KBA';
var IDENTITY_FETCH_KBA_SUCCESS = "".concat(IDENTITY_FETCH_KBA, "_SUCCESS");
var IDENTITY_FETCH_KBA_ERROR = "".concat(IDENTITY_FETCH_KBA, "_ERROR");
var IDENTITY_VERIFY_KBA = 'CS/IDENTITY_VERIFY_KBA';
var IDENTITY_VERIFY_KBA_SUCCESS = "".concat(IDENTITY_VERIFY_KBA, "_SUCCESS");
var IDENTITY_VERIFY_KBA_ERROR = "".concat(IDENTITY_VERIFY_KBA, "_ERROR");
var IDENTITY_VERIFY_BAV = 'CS/IDENTITY_VERIFY_BAV';
var IDENTITY_VERIFY_BAV_SUCCESS = "".concat(IDENTITY_VERIFY_BAV, "_SUCCESS");
var IDENTITY_VERIFY_BAV_ERROR = "".concat(IDENTITY_VERIFY_BAV, "_ERROR");
var IDENTITY_SKIP_BAV = 'CS/IDENTITY_SKIP_BAV';
var IDENTITY_SKIP_BAV_SUCCESS = "".concat(IDENTITY_SKIP_BAV, "_SUCCESS");
var IDENTITY_SKIP_BAV_ERROR = "".concat(IDENTITY_SKIP_BAV, "_ERROR");
var IDENTITY_MARKETING_USER = 'CS/IDENTITY_MARKETING_USER';
var IDENTITY_SKIP_OTP = 'CS/IDENTITY_SKIP_OTP';
var IDENTITY_SKIP_OTP_SUCCESS = "".concat(IDENTITY_SKIP_OTP, "_SUCCESS");
var IDENTITY_SKIP_OTP_ERROR = "".concat(IDENTITY_SKIP_OTP, "_ERROR");
var IDENTITY_SKIP_REIDENTIFY = 'CS/IDENTITY_SKIP_REIDENTIFY';
var IDENTITY_SKIP_REIDENTIFY_SUCCESS = "".concat(IDENTITY_SKIP_REIDENTIFY, "_SUCCESS");
var IDENTITY_SKIP_REIDENTIFY_ERROR = "".concat(IDENTITY_SKIP_REIDENTIFY, "_ERROR");
var IDENTITY_EMPTY = 'CS/IDENTITY_EMPTY';
var typesImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IDENTITY_IDENTIFY: IDENTITY_IDENTIFY,
  IDENTITY_IDENTIFY_SUCCESS: IDENTITY_IDENTIFY_SUCCESS,
  IDENTITY_IDENTIFY_ERROR: IDENTITY_IDENTIFY_ERROR,
  IDENTITY_REIDENTIFY: IDENTITY_REIDENTIFY,
  IDENTITY_REIDENTIFY_SUCCESS: IDENTITY_REIDENTIFY_SUCCESS,
  IDENTITY_REIDENTIFY_ERROR: IDENTITY_REIDENTIFY_ERROR,
  IDENTITY_RESTART: IDENTITY_RESTART,
  IDENTITY_RESTART_SUCCESS: IDENTITY_RESTART_SUCCESS,
  IDENTITY_RESTART_ERROR: IDENTITY_RESTART_ERROR,
  IDENTITY_GENERATE_TOKEN: IDENTITY_GENERATE_TOKEN,
  IDENTITY_GENERATE_TOKEN_SUCCESS: IDENTITY_GENERATE_TOKEN_SUCCESS,
  IDENTITY_GENERATE_TOKEN_ERROR: IDENTITY_GENERATE_TOKEN_ERROR,
  IDENTITY_VERIFY_OTP_TOKEN: IDENTITY_VERIFY_OTP_TOKEN,
  IDENTITY_VERIFY_OTP_TOKEN_SUCCESS: IDENTITY_VERIFY_OTP_TOKEN_SUCCESS,
  IDENTITY_VERIFY_OTP_TOKEN_ERROR: IDENTITY_VERIFY_OTP_TOKEN_ERROR,
  IDENTITY_CHOOSE: IDENTITY_CHOOSE,
  IDENTITY_CHOOSE_SUCCESS: IDENTITY_CHOOSE_SUCCESS,
  IDENTITY_CHOOSE_ERROR: IDENTITY_CHOOSE_ERROR,
  IDENTITY_FIRST_TIME_VISIT: IDENTITY_FIRST_TIME_VISIT,
  IDENTITY_FIRST_TIME_REGISTRATION: IDENTITY_FIRST_TIME_REGISTRATION,
  IDENTITY_FETCH_KBA: IDENTITY_FETCH_KBA,
  IDENTITY_FETCH_KBA_SUCCESS: IDENTITY_FETCH_KBA_SUCCESS,
  IDENTITY_FETCH_KBA_ERROR: IDENTITY_FETCH_KBA_ERROR,
  IDENTITY_VERIFY_KBA: IDENTITY_VERIFY_KBA,
  IDENTITY_VERIFY_KBA_SUCCESS: IDENTITY_VERIFY_KBA_SUCCESS,
  IDENTITY_VERIFY_KBA_ERROR: IDENTITY_VERIFY_KBA_ERROR,
  IDENTITY_VERIFY_BAV: IDENTITY_VERIFY_BAV,
  IDENTITY_VERIFY_BAV_SUCCESS: IDENTITY_VERIFY_BAV_SUCCESS,
  IDENTITY_VERIFY_BAV_ERROR: IDENTITY_VERIFY_BAV_ERROR,
  IDENTITY_SKIP_BAV: IDENTITY_SKIP_BAV,
  IDENTITY_SKIP_BAV_SUCCESS: IDENTITY_SKIP_BAV_SUCCESS,
  IDENTITY_SKIP_BAV_ERROR: IDENTITY_SKIP_BAV_ERROR,
  IDENTITY_MARKETING_USER: IDENTITY_MARKETING_USER,
  IDENTITY_SKIP_OTP: IDENTITY_SKIP_OTP,
  IDENTITY_SKIP_OTP_SUCCESS: IDENTITY_SKIP_OTP_SUCCESS,
  IDENTITY_SKIP_OTP_ERROR: IDENTITY_SKIP_OTP_ERROR,
  IDENTITY_SKIP_REIDENTIFY: IDENTITY_SKIP_REIDENTIFY,
  IDENTITY_SKIP_REIDENTIFY_SUCCESS: IDENTITY_SKIP_REIDENTIFY_SUCCESS,
  IDENTITY_SKIP_REIDENTIFY_ERROR: IDENTITY_SKIP_REIDENTIFY_ERROR,
  IDENTITY_EMPTY: IDENTITY_EMPTY
});
var identify = function identify(blackBox) {
  return createAction(IDENTITY_IDENTIFY, createRequestPayload('international', '/cs-identity/v1/identify', 'post', {
    beginBlackbox: blackBox
  }));
};
var reidentify = function reidentify(market, blackBox) {
  return createAction(IDENTITY_REIDENTIFY, createRequestPayload('international', marketConfig(market).reidentify, 'post', blackBox ? {
    beginBlackbox: blackBox
  } : undefined));
};
var skipReidentify = function skipReidentify(market, blackBox) {
  return createAction(IDENTITY_SKIP_REIDENTIFY, createRequestPayload('international', marketConfig(market).skipReidentify, 'post', blackBox ? {
    beginBlackbox: blackBox
  } : undefined));
};
var restart = function restart() {
  return createAction(IDENTITY_RESTART, createRequestPayload('international', "/cs-identity/v1/restart", 'post'));
};
var generateToken = function generateToken() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$isResend = _ref.isResend,
    _isResend = _ref$isResend === void 0 ? false : _ref$isResend;
  return createAction(IDENTITY_GENERATE_TOKEN, createRequestPayload('international', '/cs-identity/v2/otp/generate', 'post', null, {
    isResend: _isResend
  }));
};
var verifyOtpToken = function verifyOtpToken(data) {
  return createAction(IDENTITY_VERIFY_OTP_TOKEN, createRequestPayload('international', "/cs-identity/v1/otp/verify/".concat(data.otpCandidate), 'post'));
};
var choose = function choose(data) {
  return createAction(IDENTITY_CHOOSE, createRequestPayload('international', '/cs-identity/v1/choose', 'post', data));
};
var firstTimeVisit = function firstTimeVisit() {
  return createAction(IDENTITY_FIRST_TIME_VISIT);
};
var firstTimeRegistration = function firstTimeRegistration() {
  return createAction(IDENTITY_FIRST_TIME_REGISTRATION);
};
var fetchKba = function fetchKba() {
  return createAction(IDENTITY_FETCH_KBA, createRequestPayload('international', "/cs-identity/v1/kba"));
};
var verifyKba = function verifyKba(data) {
  return createAction(IDENTITY_VERIFY_KBA, createRequestPayload('international', "/cs-identity/v1/kba/verify", 'post', data));
};
var verifyBav = function verifyBav(data) {
  return createAction(IDENTITY_VERIFY_BAV, createRequestPayload('international', "/cs-identity/v1/bav/verify", 'post', data));
};
var skipBav = function skipBav() {
  return createAction(IDENTITY_SKIP_BAV, createRequestPayload('international', "/cs-identity/v1/bav/skip", 'post'));
};
var trackUserCameFromMarketingSource = function trackUserCameFromMarketingSource(_ref2) {
  var context = _ref2.context;
  return createAction(IDENTITY_MARKETING_USER, {
    context: context
  });
};
var skipOtp = function skipOtp() {
  return createAction(IDENTITY_SKIP_OTP, createRequestPayload('international', "/cs-identity/v1/otp/skip", 'post'));
};
var actionsImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  identify: identify,
  reidentify: reidentify,
  skipReidentify: skipReidentify,
  restart: restart,
  generateToken: generateToken,
  verifyOtpToken: verifyOtpToken,
  choose: choose,
  firstTimeVisit: firstTimeVisit,
  firstTimeRegistration: firstTimeRegistration,
  fetchKba: fetchKba,
  verifyKba: verifyKba,
  verifyBav: verifyBav,
  skipBav: skipBav,
  trackUserCameFromMarketingSource: trackUserCameFromMarketingSource,
  skipOtp: skipOtp
});
var initialState = {
  fetchStatus: requestStatuses.INITIAL,
  chooseStatus: requestStatuses.INITIAL,
  verifyStatus: requestStatuses.INITIAL,
  otpVerifyStatus: requestStatuses.INITIAL,
  bavStatus: requestStatuses.INITIAL,
  reidentifyStatus: requestStatuses.INITIAL,
  otpSkipStatus: requestStatuses.INITIAL,
  skipReidentifyStatus: requestStatuses.INITIAL
};
var domain = function domain() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case IDENTITY_IDENTIFY:
    case IDENTITY_GENERATE_TOKEN:
    case IDENTITY_FETCH_KBA:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchStatus: requestStatuses.PENDING
      });
    case IDENTITY_VERIFY_OTP_TOKEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        otpVerifyStatus: requestStatuses.PENDING
      });
    case IDENTITY_VERIFY_KBA:
      return _objectSpread(_objectSpread({}, state), {}, {
        verifyStatus: requestStatuses.PENDING
      });
    case IDENTITY_IDENTIFY_SUCCESS:
    case IDENTITY_FETCH_KBA_SUCCESS:
      return _objectSpread(_objectSpread(_objectSpread({}, state), payload), {}, {
        fetchStatus: requestStatuses.SUCCESS
      });
    case IDENTITY_VERIFY_OTP_TOKEN_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        accountIDVStatus: payload.accountIDVStatus,
        otpVerifyStatus: requestStatuses.SUCCESS
      });
    case IDENTITY_VERIFY_KBA_SUCCESS:
      return _objectSpread(_objectSpread(_objectSpread({}, state), payload), {}, {
        verifyStatus: requestStatuses.SUCCESS
      });
    case IDENTITY_GENERATE_TOKEN_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        email: payload.email,
        mobileNumber: payload.mobileNumber,
        fetchStatus: requestStatuses.SUCCESS
      });
    case IDENTITY_GENERATE_TOKEN_ERROR:
      if (payload.status === 400) {
        return _objectSpread(_objectSpread({}, state), {}, {
          email: payload.data.email,
          mobileNumber: payload.data.mobileNumber,
          fetchStatus: requestStatuses.SUCCESS
        });
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchStatus: requestStatuses.ERROR
      });
    case IDENTITY_VERIFY_OTP_TOKEN_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        otpVerifyStatus: requestStatuses.ERROR
      });
    case IDENTITY_IDENTIFY_ERROR:
    case IDENTITY_FETCH_KBA_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchStatus: requestStatuses.ERROR
      });
    case IDENTITY_VERIFY_KBA_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        verifyStatus: requestStatuses.ERROR
      });
    case IDENTITY_CHOOSE:
      return _objectSpread(_objectSpread({}, state), {}, {
        chooseStatus: requestStatuses.PENDING
      });
    case IDENTITY_CHOOSE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        chooseStatus: requestStatuses.SUCCESS
      });
    case IDENTITY_CHOOSE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        chooseStatus: requestStatuses.ERROR
      });
    case IDENTITY_VERIFY_BAV:
    case IDENTITY_SKIP_BAV:
      return _objectSpread(_objectSpread({}, state), {}, {
        bavStatus: requestStatuses.PENDING
      });
    case IDENTITY_SKIP_OTP:
      return _objectSpread(_objectSpread({}, state), {}, {
        otpSkipStatus: requestStatuses.PENDING
      });
    case IDENTITY_VERIFY_BAV_SUCCESS:
    case IDENTITY_SKIP_BAV_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        bavStatus: requestStatuses.SUCCESS
      });
    case IDENTITY_SKIP_OTP_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        otpSkipStatus: requestStatuses.SUCCESS
      });
    case IDENTITY_VERIFY_BAV_ERROR:
    case IDENTITY_SKIP_BAV_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        bavStatus: requestStatuses.ERROR
      });
    case IDENTITY_SKIP_OTP_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        otpSkipStatus: requestStatuses.ERROR
      });
    case IDENTITY_REIDENTIFY:
      return _objectSpread(_objectSpread({}, state), {}, {
        reidentifyStatus: requestStatuses.PENDING
      });
    case IDENTITY_REIDENTIFY_SUCCESS:
      return _objectSpread(_objectSpread(_objectSpread({}, state), payload), {}, {
        reidentifyStatus: requestStatuses.SUCCESS
      });
    case IDENTITY_REIDENTIFY_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        reidentifyStatus: requestStatuses.ERROR
      });
    case IDENTITY_RESTART:
      return _objectSpread(_objectSpread({}, state), {}, {
        restartStatus: requestStatuses.PENDING
      });
    case IDENTITY_RESTART_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        restartStatus: requestStatuses.SUCCESS
      });
    case IDENTITY_RESTART_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        restartStatus: requestStatuses.ERROR
      });
    case IDENTITY_SKIP_REIDENTIFY:
      return _objectSpread(_objectSpread({}, state), {}, {
        skipReidentifyStatus: requestStatuses.PENDING
      });
    case IDENTITY_SKIP_REIDENTIFY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        skipReidentifyStatus: requestStatuses.SUCCESS
      });
    case IDENTITY_SKIP_REIDENTIFY_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        skipReidentifyStatus: requestStatuses.ERROR
      });
    default:
      return state;
  }
};
var reducersImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  domain: domain,
  'default': domain
});
var getFetchStatus = function getFetchStatus(state) {
  return resolveRequest(state, 'identity.fetchStatus');
};
var getRestartStatus = function getRestartStatus(state) {
  return resolveRequest(state, 'identity.restartStatus');
};
var getChooseStatus = function getChooseStatus(state) {
  return resolveRequest(state, 'identity.chooseStatus');
};
var getVerifyStatus = function getVerifyStatus(state) {
  return resolveRequest(state, 'identity.verifyStatus');
};
var getOtpVerifyStatus = function getOtpVerifyStatus(state) {
  return resolveRequest(state, 'identity.otpVerifyStatus');
};
var getBavStatus = function getBavStatus(state) {
  return resolveRequest(state, 'identity.bavStatus');
};
var getReidentifyStatus = function getReidentifyStatus(state) {
  return resolveRequest(state, 'identity.reidentifyStatus');
};
var getSkipReidentifyStatus = function getSkipReidentifyStatus(state) {
  return resolveRequest(state, 'identity.skipReidentifyStatus');
};
var getOtpSkipStatus = function getOtpSkipStatus(state) {
  return resolveRequest(state, 'identity.otpSkipStatus');
};
var identityGetPredicate = createSelector(getFetchStatus, getRestartStatus, getChooseStatus, getVerifyStatus, getOtpVerifyStatus, getBavStatus, getReidentifyStatus, getSkipReidentifyStatus, getOtpSkipStatus, function (fetchStatus, restartStatus, chooseStatus, verifyStatus, otpVerifyStatus, bavStatus, reidentifyStatus, skipReidentifyStatus, otpSkipStatus) {
  return {
    fetch: getRequestStatus(fetchStatus),
    restart: getRequestStatus(restartStatus),
    choose: getRequestStatus(chooseStatus),
    verify: getRequestStatus(verifyStatus),
    otpVerify: getRequestStatus(otpVerifyStatus),
    bav: getRequestStatus(bavStatus),
    reidentify: getRequestStatus(reidentifyStatus),
    skipReidentify: getRequestStatus(skipReidentifyStatus),
    otpSkipStatus: getRequestStatus(otpSkipStatus)
  };
});
var getMobileNumber = function getMobileNumber(state) {
  return resolveProp('identity.mobileNumber', state);
};
var getMaskedNumberData = function getMaskedNumberData(state) {
  return resolveProp('identity.maskedNumberData.maskedNumbers', state) || [];
};
var identityGetPhoneNumbers = createSelector(getMobileNumber, getMaskedNumberData, function (mobileNumber, maskedNumbers) {
  return {
    mobileNumber: mobileNumber,
    maskedNumbers: maskedNumbers
  };
});
var getEmail$1 = function getEmail$1(state) {
  return resolveProp('identity.email', state);
};
var getMaskedEmailData = function getMaskedEmailData(state) {
  return resolveProp('identity.maskedEmailData.maskedEmailAddresses', state) || [];
};
var identityGetEmail = createSelector(getEmail$1, getMaskedEmailData, function (email, maskedEmailAddresses) {
  return {
    email: email,
    maskedEmailAddresses: maskedEmailAddresses
  };
});
var getRequestId = function getRequestId(state) {
  return resolveProp('identity.idRequestId', state);
};
var identityGetKbaRequestId = createSelector(getRequestId, function (idRequestId) {
  return {
    requestId: idRequestId
  };
});
var getQuestions = function getQuestions(state) {
  return resolveProp('identity.challengeQuestions', state) || [];
};
var identityGetKbaQuestions = createSelector(getQuestions, function (questions) {
  return {
    questions: questions
  };
});
var getShowKbaStatus$1 = function getShowKbaStatus$1(state) {
  return resolveProp('identity.showKba', state);
};
var identityGetShowKbaStatus = createSelector(getShowKbaStatus$1, function (showKbaStatus) {
  return {
    showKbaStatus: showKbaStatus
  };
});
var getAccountIDVStatus = function getAccountIDVStatus(state) {
  return resolveProp('identity.accountIDVStatus', state);
};
var identityGetStatus = createSelector(getAccountIDVStatus, function (accountIDVStatus) {
  return {
    accountIDVStatus: accountIDVStatus
  };
});
var getFailureReason$1 = function getFailureReason$1(state) {
  return resolveProp('identity.failureReason', state);
};
var identityGetFailureReason = createSelector(getFailureReason$1, function (failureReason) {
  return {
    failureReason: failureReason
  };
});
var getPredicate = identityGetPredicate;
var getPhoneNumbers = identityGetPhoneNumbers;
var getEmail = identityGetEmail;
var getKbaRequestId = identityGetKbaRequestId;
var getKbaQuestions = identityGetKbaQuestions;
var getShowKbaStatus = identityGetShowKbaStatus;
var getStatus = identityGetStatus;
var getFailureReason = identityGetFailureReason;
var selectorsImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getPredicate: getPredicate,
  getPhoneNumbers: getPhoneNumbers,
  getEmail: getEmail,
  getKbaRequestId: getKbaRequestId,
  getKbaQuestions: getKbaQuestions,
  getShowKbaStatus: getShowKbaStatus,
  getStatus: getStatus,
  getFailureReason: getFailureReason
});
var actions = actionsImport;
var reducers = reducersImport;
var selectors = selectorsImport;
var types = typesImport;
export { actions, reducers, selectors, types };